import { Bundles } from '../../util/moduleLoader';

import useModuleLoader from '../../hooks/useModuleLoader';

const AuthImportSessionAsync = () => {
  const AuthImportSession = useModuleLoader(Bundles.Auth, 'AuthImportSession');

  return AuthImportSession ? <AuthImportSession /> : null;
};

export default AuthImportSessionAsync;
